<ul class="MyMoeinList">

      <li *ngFor="let item of DataList_History">
          <a *ngIf="item.sender">
            <i class="fa fa-user"></i>
            From &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp; <b>{{item.sender}} ({{item.order}})</b> &emsp;&emsp; to &emsp;&emsp; <b>{{item.giver}} ({{item.semat_giver}})</b>
          </a>
          <a *ngIf="!item.sender">
            <i class="fa fa-file-text"></i>
             <b> Letter {{item.id}} Created by {{item.giver}} </b> 
          </a>
          <div class="subMoeinDiv">
              <img src="{{BaseUrl}}{{item.imageUser}}" />
              <div class="subMoeinDivDetail">
                  <p> Sender: {{item.sender}} ({{item.semat_sender}}) </p>
                  <p> Recipient : {{item.giver}} ({{item.semat_giver}}) </p>
                  <h6>{{item.order}}</h6>
              </div>
              <div style="clear:both"></div>
              <p class="subMoeinDsc"> Description : {{item.dsc}} </p>
              <p class="subMoeinFooter"> Sent At : {{item.persianDate}}</p>
              <p class="subMoeinFooter"> View Time : {{item.visitDate}}</p>


              <p *ngIf="item.notes.length>0" class="subMoeinDsc"> Note : </p>

              <ul *ngIf="item.notes.length>0">
                  <li class="MyNote"  *ngFor="let note of item.notes">{{note.message}} ({{note.fullname}} , {{note.persianDate}})</li>
              </ul>

          </div>
          <app-LetterRequestCustomerHistory [DataList_History]="item.detail"></app-LetterRequestCustomerHistory>
      </li>
</ul>
